import PrivacyPolicyScreencreen from './PrivacyPolicyScreen'


export const PRIVACY_POLICY_ROUTE = "/privacypolicy";

export const routes = [
    {
        path: PRIVACY_POLICY_ROUTE,
        component: PrivacyPolicyScreencreen,
        exact: true,
        public: true
    },
];